import { isNotDefined } from '@sgme/fp';
import classNames from 'classnames';

export type TrafficLightColor = 'success' | 'warning' | 'danger';

export interface TrafficLightProps {
  color?: TrafficLightColor;
  className?: string;
  size?: string;
}
export function TrafficLight({ color, className, size = 'sm' }: TrafficLightProps) {
  return isNotDefined(color) ? null : (
    <i className={classNames(`icon icon-${size} mx-1 me-1 text-${color}`, className)}>fiber_manual_record</i>
  );
}
export function getTrafficLightColor(isLoading: boolean, hasError: boolean): TrafficLightColor {
  if (isLoading) {
    return 'warning';
  }
  return hasError ? 'danger' : 'success';
}
